__turbopack_context__.v({
  "productMain": "product-page-main-module-scss-module__zwm_yq__productMain",
  "productMainBanner": "product-page-main-module-scss-module__zwm_yq__productMainBanner",
  "productMainMobileTitle": "product-page-main-module-scss-module__zwm_yq__productMainMobileTitle",
});
